<div class="ttmodal" *ngIf="isInstructions==false">
  <div class="ttmodal__header">
      <span class="ttmodal__title">{{header}}</span>
      <a class="button waves-effect" (click)="onNoClick()">
        <i class="material-icons button__icon">cancel</i>
        <span class="button__text">Close</span>
      </a>
  </div>
  <div class="ttmodal__body" >
      <div class="input-container">
          <span class="label">Add Comment <span class="red-text"></span></span>
          <textarea rows="8" [(ngModel)]="comment" type="text" placeholder="New Comment"  style="width: 860px;"></textarea>
      </div>
      <div class="ttmodal__footer">
        <!-- <button class="button button--primary" style="color: white;" (click)="onSave()" >Save</button> -->
        <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
        <button mat-raised-button color="warn" (click)="onSave()">
          <i class="material-icons button__icon">save</i><span class="button__text">
            Save
          </span>
        </button>
      </div>
  </div>

  <div class="ttmodal__footer" style="height: 360px;overflow-y: auto;">
        <table  class="table table--full-width table--striped table--hover">
          <thead>
              <tr>
                  <th>History</th>
              </tr>
          </thead>
          <tbody>
              <ng-container *ngFor="let com of commentlist">
                  <tr>
                      <td class=" columncell">{{com}}</td>
                  </tr>
              </ng-container>
          </tbody>
      </table>
  </div>
</div>


<div class="ttmodal" *ngIf="isInstructions==true">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Question Instructions</span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
    </div>
    <div class="ttmodal__body" >
        <div class="input-container">
            <span class="label">Instructions <span class="red-text"></span></span>
            <textarea rows="10" [(ngModel)]="comment" type="text" placeholder="New Comment"  style="width: 450px;" disabled></textarea>
        </div>
        <div>
          <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
        </div>
    </div>  
</div>